import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export function useGetNotifications() {
  const { data, isLoading } = useQuery(
    ["notifications"],
    () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/notification`)
        .then((response) => {
          return response.data;
        }),
    {
      refetchOnWindowFocus: true,
      refetchInterval: 10000,
      refetchIntervalInBackground: true

    }
  );

  return {
    data,
    loading: isLoading,
  };
}
